export const onClickDisableHref = (e: any) => {
  e.preventDefault();
  return false;
};
